<template>
    <Internal>

        <BreadcrumbsComponent :pages="pages" :is-dashboard="false"/>
        <div class="grid gap-4 grid-cols-9 -mt-4">
            <div class="col-span-full">
                <Table :fields="fields"
                       :items="topics"
                       :canView="true"
                       :empty_message="`${_type} not found`"
                >
                    <template #topic="{item}">
                        {{ item?.topic?.title }}
                    </template>
                    <template #review="{item}">
                        {{ item?.review == '' ? '-' : item?.review }}
                    </template>
                    <template #rating="{item}">
                        {{ item?.rating }} / 5
                    </template>
                    <template #teacher="{item}">
                        <inertia-link class="text-blue-600 hover:!underline"
                                      :href="route('administrative.faculty.view',item.faculty.id)"
                                      v-if="hasRole('View Faculty')">
                            {{ item.faculty.first_name }} {{ item.faculty.middle_name }} {{ item.faculty.last_name }}
                        </inertia-link>
                        <p v-else class="cursor-not-allowed">
                            {{ item.faculty.first_name }} {{ item.faculty.middle_name }} {{ item.faculty.last_name }}
                        </p>
                    </template>

                </Table>
            </div>

        </div>
    </Internal>
</template>
<script setup>
import Internal from "@/Pages/Internal/Internal.vue";
import {usePage} from "@inertiajs/inertia-vue3";
import Table from "@/Components/Table.vue";
import {hasRole} from "../../../../../Utils/checkPermission";
import BreadcrumbsComponent from "@/Components/BreadcrumbsComponent.vue";

const topics = usePage().props.value.topics ?? [];
const admission = usePage().props.value.admission ?? {};
const branch = usePage().props.value.branch ?? {};
const _type = "Review";

const fields = [
    {'key': 'topic', 'label': 'Subject'},
    {'key': 'teacher', 'label': 'Teacher'},
    {'key': 'rating', 'label': 'rating'},
    {'key': 'review', 'label': 'review'},
];
const pages = [
    {name: 'Admissions', href: route('internal.admission.list',branch.id), current: false},
    {
        name: ` ${admission?.student?.first_name} ${admission?.student?.last_name}`,
        href: `${route('internal.admission.view', [branch.id, admission.id])}?activeTab=Performance`,
        current: false
    },
    {name: 'Vivas', current: true},
]
</script>
